import { useState } from "react"
import { flexRender } from "@tanstack/react-table"
import type { Table } from "@tanstack/react-table"
import { Icon } from "@mdi/react"
import { mdiMenuDown, mdiMenuUp } from "@mdi/js"

import Pagination from "./pagination"
import TableHeader from "./header"

interface Props<T> {
  table: Table<T>
  filterOn?: string
  dateField?: string
  tableLoading: boolean
  noPagination?: boolean
}

const Table = <T,>(props: Props<T>) => {
  const { table, filterOn, dateField, tableLoading, noPagination } = props
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <>
      <div className="hidden w-full p-6 bg-white rounded md:block">
        <TableHeader
          table={table}
          noPagination={noPagination}
          filterOn={filterOn}
          dateField={dateField}
        />
        <table className="w-full">
          <thead>
            {table.getHeaderGroups().map(headerGroup => (
              <tr
                key={headerGroup.id}
                className="h-12 border-b even:bg-primary-light border-b-neutral"
              >
                {headerGroup.headers.map(header => (
                  <th
                    key={header.id}
                    colSpan={header.colSpan}
                    className="px-4 text-left"
                    onClick={header.column.getToggleSortingHandler()}
                  >
                    <div className="flex items-center gap-2">
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                      {{
                        asc: (
                          <div className="rounded bg-neutral">
                            <Icon
                              path={mdiMenuUp}
                              size={1}
                              className="-m-0.5"
                            />
                          </div>
                        ),
                        desc: (
                          <div className="rounded bg-neutral">
                            <Icon
                              path={mdiMenuDown}
                              size={1}
                              className="-m-0.5"
                            />
                          </div>
                        ),
                      }[header.column.getIsSorted() as string] ?? null}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map(row => (
              <tr key={row.id} className="h-12 even:bg-primary-light">
                {row.getVisibleCells().map(cell => (
                  <td key={cell.id} className="px-4">
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        {!noPagination && (
          <Pagination table={table} tableLoading={tableLoading} />
        )}
      </div>

      <div className="flex flex-col w-5/6 gap-2 mx-auto md:hidden">
        <TableHeader table={table} filterOn={filterOn} />

        {table.getPrePaginationRowModel().rows.map(row => (
          <div key={row.id} className="flex flex-col gap-2 px-4 py-3 bg-white ">
            {row.getVisibleCells().map(cell => {
              return (
                <div key={cell.id} className="">
                  {false ? (
                    <h3 className="mb-0 text-xs font-bold">
                      {cell.column.columnDef.header?.toString()}
                    </h3>
                  ) : null}
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </div>
              )
            })}
          </div>
        ))}
      </div>
    </>
  )
}

export default Table
